import { Mail, User, Laptop, MapPin, Clock, ArrowRight } from 'lucide-react';
import PublicShell from '@/components/layouts/PublicShell';

const StellenAngebotePage = () => {
  return (
    <PublicShell>
      {/* Hero */}
      <div className="relative bg-primary-950 overflow-hidden">
        <img src="/images/sv-careers-office.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/85 to-transparent" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-16 sm:py-20 md:py-24">
          <div className="max-w-2xl">
            <span className="text-xs font-semibold uppercase tracking-[0.14em] text-gold-400 mb-4 block">Sky View GmbH</span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif font-medium text-white mb-6 leading-tight">
              Karriere bei uns
            </h1>
            <div className="w-16 h-[3px] bg-gold-500 mb-6"></div>
            <p className="text-base sm:text-lg text-primary-200 leading-relaxed">
              Werden Sie Teil unseres Teams und gestalten Sie gemeinsam mit uns die Zukunft der Finanzberatung.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-primary-50/40 py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto space-y-8">
            {/* Job 1: Vermoegensverwalter */}
            <div className="bg-white border border-slate-200 border-t-2 border-t-gold-500 p-6 sm:p-10">
              <div className="mb-8">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-primary-50 flex items-center justify-center shrink-0">
                    <User className="w-6 h-6 text-primary-700" />
                  </div>
                  <div>
                    <h2 className="text-xl sm:text-2xl font-serif font-medium text-slate-900">Vermögensverwalter (m/w/d)</h2>
                    <div className="flex items-center gap-4 mt-2 text-sm text-slate-500">
                      <div className="flex items-center gap-1.5">
                        <MapPin className="w-4 h-4" />
                        <span>Frankfurt am Main</span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <Clock className="w-4 h-4" />
                        <span>Vollzeit</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-serif font-medium text-slate-900 mb-3">Über uns</h3>
                  <p className="text-slate-600 leading-relaxed">
                    Sky View GmbH ist ein unabhängiger Partner für Vermögensverwaltung und bietet maßgeschneiderte Finanzlösungen für Privat- und Geschäftskunden. Unser Team aus erfahrenen Fachleuten nutzt eine Kombination aus fundiertem Marktverständnis und modernen Analysetools, um langfristige, nachhaltige Wertsteigerung für unsere Kunden zu gewährleisten.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-serif font-medium text-slate-900 mb-3">Ihre Aufgaben</h3>
                  <ul className="list-disc list-inside text-slate-600 space-y-2 leading-relaxed">
                    <li><strong className="text-slate-900 font-semibold">Beratung und Betreuung von Kunden:</strong> Entwicklung und Umsetzung individueller Anlagestrategien unter Berücksichtigung der finanziellen Ziele und Risikoprofile unserer Klienten.</li>
                    <li><strong className="text-slate-900 font-semibold">Analyse und Marktbeobachtung:</strong> Laufende Marktanalysen und Identifikation von Investmentmöglichkeiten in verschiedenen Anlageklassen (Aktien, Anleihen, Immobilien, alternative Investments).</li>
                    <li><strong className="text-slate-900 font-semibold">Portfoliomanagement:</strong> Erstellung und regelmäßige Anpassung von Portfolios zur Maximierung der Rendite unter Berücksichtigung von Risikoaspekten und Steueroptimierung.</li>
                    <li><strong className="text-slate-900 font-semibold">Berichterstattung:</strong> Regelmäßige und transparente Kommunikation der Portfolioentwicklung und -performance an Kunden.</li>
                    <li><strong className="text-slate-900 font-semibold">Koordination mit anderen Abteilungen:</strong> Enge Zusammenarbeit mit der Steuerberatung, Rechtsabteilung und anderen internen Teams zur Sicherstellung einer ganzheitlichen und optimalen Betreuung.</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-serif font-medium text-slate-900 mb-3">Ihr Profil</h3>
                  <ul className="list-disc list-inside text-slate-600 space-y-2 leading-relaxed">
                    <li>Abgeschlossenes Studium der Wirtschaftswissenschaften, Finanzwirtschaft, Betriebswirtschaftslehre oder einer vergleichbaren Disziplin.</li>
                    <li>Mehrjährige Erfahrung im Bereich der Vermögensverwaltung oder Finanzberatung, idealerweise mit einem Hintergrund in der Analyse und dem Management von Investitionen.</li>
                    <li>Fundierte Kenntnisse in den Bereichen Finanzmärkte, Portfolio-Management, Risikomanagement und Kapitalanlage.</li>
                    <li>Sehr gute Kenntnisse in der Anwendung von Finanzsoftware und Analysetools (z.B. Bloomberg, Morningstar, etc.).</li>
                    <li>Ausgeprägte analytische Fähigkeiten, eine strukturierte Arbeitsweise und ein hohes Maß an Eigeninitiative.</li>
                    <li>Kommunikationsstärke und hohe Kundenorientierung, gepaart mit der Fähigkeit, komplexe Sachverhalte verständlich zu vermitteln.</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-serif font-medium text-slate-900 mb-3">Wir bieten</h3>
                  <ul className="list-disc list-inside text-slate-600 space-y-2 leading-relaxed">
                    <li>Ein dynamisches und internationales Arbeitsumfeld.</li>
                    <li>Spannende Entwicklungsmöglichkeiten in einem wachstumsorientierten Unternehmen.</li>
                    <li>Eine leistungsgerechte Vergütung und attraktive Zusatzleistungen.</li>
                    <li>Flexible Arbeitszeiten und ein angenehmes Arbeitsklima.</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Job 2: IT-Spezialist */}
            <div className="bg-white border border-slate-200 border-t-2 border-t-gold-500 p-6 sm:p-10">
              <div className="mb-8">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gold-50 flex items-center justify-center shrink-0">
                    <Laptop className="w-6 h-6 text-gold-700" />
                  </div>
                  <div>
                    <h2 className="text-xl sm:text-2xl font-serif font-medium text-slate-900">IT-Spezialist (m/w/d)</h2>
                    <div className="flex items-center gap-4 mt-2 text-sm text-slate-500">
                      <div className="flex items-center gap-1.5">
                        <MapPin className="w-4 h-4" />
                        <span>Frankfurt am Main</span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <Clock className="w-4 h-4" />
                        <span>Vollzeit</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-serif font-medium text-slate-900 mb-3">Über uns</h3>
                  <p className="text-slate-600 leading-relaxed">
                    Sky View GmbH setzt auf moderne Technologie, um Kundinnen und Kunden erstklassige Lösungen zu bieten. Wir suchen einen engagierten IT-Spezialisten, der unsere Systeme kontinuierlich verbessert und sicherstellt, dass wir technologisch immer einen Schritt voraus sind.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-serif font-medium text-slate-900 mb-3">Ihre Aufgaben</h3>
                  <ul className="list-disc list-inside text-slate-600 space-y-2 leading-relaxed">
                    <li><strong className="text-slate-900 font-semibold">Systemadministration:</strong> Verantwortung für die Installation, Konfiguration und Wartung von Servern, Netzwerken und IT-Infrastruktur.</li>
                    <li><strong className="text-slate-900 font-semibold">Fehlerbehebung und Support:</strong> Analyse und Behebung von IT-Problemen sowie Support für interne Mitarbeitende bei technischen Anliegen.</li>
                    <li><strong className="text-slate-900 font-semibold">IT-Sicherheitsmanagement:</strong> Sicherstellung der Sicherheit unserer Systeme und Netzwerke durch regelmäßige Überprüfungen, Updates und die Implementierung von Schutzmaßnahmen.</li>
                    <li><strong className="text-slate-900 font-semibold">Projektarbeit:</strong> Mitwirkung bei IT-Projekten, einschließlich der Einführung neuer Softwarelösungen oder der Migration von Systemen.</li>
                    <li><strong className="text-slate-900 font-semibold">Datenmanagement:</strong> Verwaltung von Datenbanken und Optimierung von IT-Prozessen, um eine hohe Verfügbarkeit und Effizienz zu gewährleisten.</li>
                    <li><strong className="text-slate-900 font-semibold">Zusammenarbeit mit externen Dienstleistern:</strong> Enge Abstimmung mit externen Partnern zur Sicherstellung einer reibungslosen Integration von Drittanbietersoftware und IT-Lösungen.</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-serif font-medium text-slate-900 mb-3">Ihr Profil</h3>
                  <ul className="list-disc list-inside text-slate-600 space-y-2 leading-relaxed">
                    <li>Abgeschlossenes Studium der Informatik, Wirtschaftsinformatik oder eine vergleichbare Qualifikation.</li>
                    <li>Mehrjährige Berufserfahrung in der Systemadministration, IT-Sicherheit und -Support.</li>
                    <li>Fundierte Kenntnisse in der Verwaltung von IT-Infrastrukturen, Netzwerken, Servern sowie gängiger Software (z.B. Windows Server, Linux, Active Directory, etc.).</li>
                    <li>Erfahrung mit Virtualisierungstechnologien und Cloud-Lösungen (z.B. AWS, Azure).</li>
                    <li>Sehr gute Kenntnisse in der Fehlerdiagnose, IT-Sicherheit und Datenbankmanagement.</li>
                    <li>Hohe Problemlösungsfähigkeit, Kommunikationsstärke und die Fähigkeit, komplexe technische Sachverhalte verständlich zu erklären.</li>
                    <li>Selbständige und strukturierte Arbeitsweise.</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-serif font-medium text-slate-900 mb-3">Wir bieten</h3>
                  <ul className="list-disc list-inside text-slate-600 space-y-2 leading-relaxed">
                    <li>Ein abwechslungsreiches Arbeitsumfeld in einem wachsenden Unternehmen.</li>
                    <li>Weiterbildungsmöglichkeiten und Zertifizierungen im IT-Bereich.</li>
                    <li>Flexible Arbeitszeiten und Home-Office-Optionen.</li>
                    <li>Eine angenehme Arbeitsatmosphäre und ein motiviertes Team.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="max-w-4xl mx-auto mt-10">
            <div className="relative overflow-hidden bg-primary-950 border-l-4 border-gold-500 px-8 py-12 md:px-14 text-center">
              <h3 className="text-2xl font-serif font-medium text-white mb-3">Interesse geweckt?</h3>
              <p className="text-primary-200 leading-relaxed mb-7 max-w-xl mx-auto">
                Senden Sie uns Ihre Bewerbung mit Lebenslauf und Motivationsschreiben.
              </p>
              <a
                href="mailto:info@skyview-assets.de"
                className="inline-flex items-center gap-2 bg-gold-500 hover:bg-gold-600 text-primary-950 font-semibold px-6 py-3.5 transition-colors"
              >
                <Mail className="w-4 h-4" />
                info@skyview-assets.de
                <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </PublicShell>
  );
};

export default StellenAngebotePage;
